import PropTypes from "prop-types";
import { useAPI, useForm } from "../../hooks";
import { Button, Select, SelectItem, TextInput } from "@tremor/react";
import { useEffect, useState } from "react";
import { AlertBox } from "../../ui";

export const RegisterUserAccessAppModal = ({
  titlePage,
  isEditMode,
  userToEditApp = null,
  cancelAndGoBack,
  idUser,
}) => {
  const { post, patch } = useAPI();
  const {
    name,
    email,
    password,
    address,
    isBuyer,
    hasAccessApp,
    taxId,
    formState,
    onInputChange,
    isFormValid,
  } = useForm({
    name: "",
    email: "",
    taxId: "",
    address: "",
    isBuyer: false,
    hasAccessApp: false,
    password: "",
    id: 0,
    isEditing: false,
  });

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!isEditMode || !userToEditApp) return;
    const keysUsers = Object.keys(userToEditApp).sort();
    for (let index = 0; index < keysUsers.length; index++) {
      const e = {
        target: {
          name: keysUsers[index],
          value: userToEditApp[keysUsers[index]],
        },
      };
      onInputChange(e);
    }
  }, [userToEditApp]);

  useEffect(() => {
    if (!hasAccessApp && !isEditMode) return;
    const time = new Date();
    const numbersEmail = time.getTime().toString().slice(-4);
    const nameEmail = name.toLowerCase().replaceAll(" ", "_");
    const password = time.getTime().toString().slice(-6);
    if (userToEditApp) return;
    const event = {
      target: {
        name: "email",
        value: `${nameEmail}_${numbersEmail}@rm.com`,
      },
    };

    const eventPassword = {
      target: {
        name: "password",
        value: password,
      },
    };

    // const eventCPassword = {
    //   target: {
    //     name: "cpassword",
    //     value: password,
    //   },
    // };

    onInputChange(event);
    onInputChange(eventPassword);
    // onInputChange(eventCPassword);
  }, [hasAccessApp, name]);

  const onSubmit = async (event) => {
    event.preventDefault();
    if (isBuyer && (taxId.trim().length <= 0 || address.trim().length <= 0)) {
      AlertBox({
        color: "warning",
        messages: ["Debe contenener un tax ID o una Dirección"],
      });
      return;
    }

    setIsLoading(true);

    const dataForm = {
      ...formState,
      idUser: userToEditApp?.idUser || idUser,
    };

    if (userToEditApp) {
      const { data, isSuccess } = await patch(
        `/admin-client/app-client/${userToEditApp.id}`,
        dataForm
      );
      if (isSuccess) {
        setIsLoading(false);
        cancelAndGoBack();
      }
      setIsLoading(false);
      return;
    }

    const { data, isSuccess } = await post(
      "/admin-client/app-client",
      dataForm
    );
    setIsLoading(false);
    if (!isSuccess) return;

    cancelAndGoBack();
  };

  const handleSelectItem = (value) => {
    const eventChange = {
      target: {
        name: "isBuyer",
        value: value === "true",
      },
    };
    onInputChange(eventChange);
  };

  const handleCheckboxChange = (event) => {
    const { checked } = event.target;
    const eventChange = {
      target: {
        name: "hasAccessApp",
        value: checked,
      },
    };
    onInputChange(eventChange);
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="absolute inset-0 bg-black opacity-50"> </div>
      <div className="bg-white p-6 rounded shadow-lg z-10">
        <h2 className="text-xl font-bold mb-4"> {titlePage}</h2>
        <form onSubmit={onSubmit}>
          <div className="grid grid-cols-2 gap-2">
            <div>
              <Select
                placeholder="Seleccionar tipo de Registro"
                onChange={handleSelectItem}
                name="isBuyer"
                value={`${isBuyer}`}
              >
                <SelectItem value="false">Cliente</SelectItem>
                <SelectItem value="true">Comprador</SelectItem>
              </Select>
            </div>
            <div className="flex items-center">
              <input
                type="checkbox"
                id="hasAccessApp"
                name="hasAccessApp"
                onChange={handleCheckboxChange}
                checked={hasAccessApp}
              />
              <label htmlFor="hasAccessApp" className="ml-1">
                Accesso a la App
              </label>
            </div>
            <div className="col-span-2">
              <p>Nombre</p>
              <TextInput
                type="text"
                placeholder="Juan Pérez"
                name="name"
                value={name}
                onChange={onInputChange}
              />
            </div>
            <div className="col-span-2">
              <p>Correo Electrónico</p>
              <TextInput
                type="email"
                placeholder="email@email.com"
                name="email"
                value={email}
                onChange={onInputChange}
              />
            </div>
            <div className="col-span-2">
              <p>Contraseña</p>
              <TextInput
                type="text"
                name="password"
                value={password}
                onChange={onInputChange}
              />
            </div>
            {isBuyer ? (
              <>
                <div>
                  <p>TAX ID</p>
                  <TextInput
                    type="text"
                    name="taxId"
                    value={taxId}
                    onChange={onInputChange}
                  />
                </div>
                <div>
                  <p>Dirección</p>
                  <TextInput
                    type="text"
                    name="address"
                    value={address}
                    onChange={onInputChange}
                  />
                </div>
              </>
            ) : (
              <></>
            )}
          </div>
          <div className="flex justify-end mt-2">
            {!isLoading && (
              <>
                <Button
                  variant="secondary"
                  onClick={cancelAndGoBack}
                  className="mr-auto"
                >
                  Cancelar
                </Button>
                <Button type="submit">Guardar Acceso</Button>
              </>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

RegisterUserAccessAppModal.propTypes = {
  titlePage: PropTypes.string,
  isEditMode: PropTypes.bool,
  userToEditApp: PropTypes.object,
  cancelAndGoBack: PropTypes.func,
  idUser: PropTypes.number,
};
